import React, {useEffect, useState} from 'react';

import {Input, Spin, Table} from "antd";
import {SearchIcon} from "lucide-react";
import {useSearchParams} from "react-router-dom";

function TableSearch({apiFn, columns, addButton, searchInput, needRefetch, setNeedRefetch, fnArgs = {}}) {

    let [searchParams, setSearchParams] = useSearchParams();
    const [dataSource, setDataSource] = useState([]);

    const [args, setArgs] = useState({
        page: searchParams.get('page') ?? 1,
        per_page: searchParams.get('per_page') ?? 20,
        search: searchParams.get('search') ?? '',
        total: 0,

    })

    useEffect(() => {
        setSearchParams({
            page: args.page,
            per_page: args.per_page,
            search: args.search ?? ''
        })
    }, [args]);

    const [inputSearchValue, setInputSearchValue] = useState()

    const [searchInputLoading, setSearchInputLoading] = useState(false)

    const {
        data,
        isPending,
        hasNextPage,
        isFetchingNextPage,
        fetchNextPage,
        refetch
    } = apiFn(
        {...fnArgs, search: args.search, page: args.page, per_page: args.per_page},
        {enabled: true}
    );


    useEffect(() => {
        setSearchInputLoading(true)
        const delaySearch = setTimeout(() => {
            setArgs({...args, search: inputSearchValue, page: 1})
            setSearchInputLoading(false)
        }, 1000)

        return () => clearTimeout(delaySearch)

    }, [inputSearchValue]);


    useEffect(() => {
        setDataSource(data?.data?.data)
        setArgs({...args, total: data?.data?.meta?.total ?? 0})

    }, [data]);

    useEffect(() => {
        if (needRefetch) {
            refetch();
            setNeedRefetch?.(false)
        }
    }, [needRefetch]);

    const handleTableChange = (pagination, filters, sorter) => {
        setArgs({...args, page: pagination.current, per_page: pagination.pageSize})
    };

    const icon = searchInputLoading ? <Spin size="small"/> : <SearchIcon className="h-4 w-4 text-gray-400"/>


    return (
        <div className="min-h-screen">


            <div className="rounded-lg shadow-sm">
                <div className="mb-2 flex flex-wrap gap-2 justify-between">
                    <div>
                        {searchInput && <div>

                            <Input suffix={icon} placeholder={`جستجو کنید ...`}
                                   rootClassName={`md:w-96`}
                                   onChange={
                                       (e) => {
                                           setInputSearchValue(e.target.value)
                                       }
                                   }
                                   value={inputSearchValue}
                            />
                        </div>
                        }
                    </div>


                    {addButton ? <div className={'flex-1'}>{addButton}</div> : null}


                </div>

                <Table
                    direction={'rtl'}
                    loading={isPending} size={`small`}
                    dataSource={dataSource}
                    columns={columns}
                    onChange={handleTableChange}
                    pagination={
                        {
                            current: args.page,
                            total: args.total,
                            pageSize: args.per_page,
                            showSizeChanger: true,
                            size: "small",
                            // itemRender : () => {},
                            showTotal: (total, range) => {
                                return ' ردیف‌های ' + range + ' از ' + total + ' ردیف '
                            },
                        }
                    }/>

            </div>
        </div>
    );
}

export default TableSearch;


